import { render, staticRenderFns } from "./address-or-depot.vue?vue&type=template&id=3084854f&"
import script from "./address-or-depot.vue?vue&type=script&lang=js&"
export * from "./address-or-depot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports